<template>
  <Layout>
    <div class="card top-draft">
      <div class="">
        <!-- <div class="col-lg-12">
          <b-button variant="primary" @click="openCreateModal()">
            <i class="bx bx-plus font-size-16 align-middle me-2"></i>
            添加
          </b-button>
        </div> -->

        <div class="col-lg-12 list-header pad-header-bg clearfix">
          <div class="header-item-fix">
            <b-form-input
              size="sm"
              type="text"
              v-model="pageParams.content"
              placeholder="请输入搜索内容"
              @keyup.enter.native="search"
            ></b-form-input>
            <b-button size="sm" variant="primary" @click="search()">
              <i class="bx bx-search-alt-2 font-size-16 align-middle"></i>
              搜索
            </b-button>
            <b-button
              size="sm"
              variant="outline-secondary"
              @click="resetParams()"
            >
              <i class="bx bx-revision font-size-16 align-middle"></i>
              重置
            </b-button>
          </div>
          <div class="header-item-fix">
            <b-form-select
              @change="search()"
              v-model="pageParams.showState"
              class="form-select"
              :options="statusOptions"
              type="text"
            ></b-form-select>
          </div>
          <div class="header-item-fix">
            <b-form-select
              @change="search()"
              v-model="pageParams.verifyState"
              class="form-select"
              :options="stateList"
              type="text"
            ></b-form-select>
          </div>
          <b-button class="btn-sm" variant="primary" @click="openCreateModal()">
            <i class="bx bx-plus font-size-16 align-middle me-2"></i>
            添加
          </b-button>
        </div>

        <div class="col-lg-12">
          <div class="table-responsive">
            <table
              class="table table-nowrap table-centered table-striped align-middle"
            >
              <thead>
                <tr>
                  <th scope="col" style="width: 70px">
                    <b-form-checkbox
                      @change="checkedAll"
                      v-model="indeterminate"
                      checked
                      plain
                    ></b-form-checkbox>
                  </th>
                  <th scope="col" style="width: 70px">ID</th>
                  <th scope="col">圈子名称</th>
                  <th scope="col" class="w-300px">图片</th>
                  <th scope="col" class="w-300px">关联媒体号</th>
                  <th scope="col">关注人数</th>
                  <th scope="col">阅读数</th>
                  <th scope="col">发帖数</th>
                  <th scope="col">审核状态</th>
                  <th scope="col">状态</th>
                  <th scope="col">创建时间</th>
                  <th scope="col">操作</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in group_list" :key="item.id">
                  <td>
                    <b-form-checkbox
                      v-model="choiceListIds"
                      :value="item.id"
                      checked
                      plain
                    ></b-form-checkbox>
                  </td>
                  <td>{{ item.id || "--" }}</td>

                  <td class="white-inherit">{{ item.name || "--" }}</td>
                  <td>
                    <img
                      :src="item.cover"
                      v-if="item.cover"
                      style="width: 50px; cursor: pointer"
                      @click="showImg(item.cover)"
                    /><span v-else>--</span>
                  </td>
                  <td class="white-inherit">
                    {{ item.mediaName || "--" }}
                  </td>
                  <td>{{ item.memberNum }}</td>
                  <td>{{ item.viewNum || "--" }}</td>
                  <td>{{ item.postNum || "--" }}</td>
                  <td>{{ showState(item.verifyState) }}</td>
                  <td>
                    <el-tooltip
                      v-if="power['显示/隐藏']"
                      :content="
                        item.showDisabled == 0 ? '点击隐藏' : '点击显示'
                      "
                    >
                      <span
                        @click="changeStatus(item)"
                        v-if="item.showDisabled == 0"
                        class="dsply-fix status-open"
                        ><i></i>显示</span
                      >
                      <span
                        @click="changeStatus(item)"
                        v-if="item.showDisabled == 1"
                        class="dsply-fix status-off"
                        ><i></i>隐藏</span
                      >
                    </el-tooltip>
                    <div v-if="!power['显示/隐藏']">
                      <span
                        v-if="item.showDisabled == 0"
                        class="dsply-fix status-open"
                        ><i></i>显示</span
                      >
                      <span
                        v-if="item.showDisabled == 1"
                        class="dsply-fix status-off"
                        ><i></i>隐藏</span
                      >
                    </div>
                  </td>
                  <td>{{ item.createAt || "--" }}</td>
                  <td>
                    <button
                      type="button"
                      class="btn-sm btn btn-primary m-r-10"
                      @click="toDetail(item)"
                      v-if="power['编辑']"
                    >
                      编辑
                    </button>

                    <button
                      type="button"
                      class="btn-sm btn btn-primary m-r-10"
                      @click="toContent(item)"
                      v-if="power['内容管理']"
                    >
                      内容管理
                    </button>

                    <button
                      type="button"
                      class="btn-sm btn btn-danger"
                      @click="deleteGroup(item.id, true)"
                      v-if="power['移除']"
                    >
                      删除
                    </button>

                    <!-- <ul class="list-inline font-size-20 contact-links mb-0">
                      <li class="list-inline-item px-2" @click="toDetail(item)">
                        <a v-b-tooltip.hover title="编辑">
                          <i class="bx bxs-edit"></i>
                        </a>
                      </li>
                      <li class="list-inline-item px-2" @click="frozenMedia(item)" v-if="item.enable == 0">
                        <a v-b-tooltip.hover title="解冻">
                          <i class="bx bx-upvote"></i>
                        </a>
                      </li>
                      <li class="list-inline-item px-2" @click="unfrozenMedia(item)" v-if="item.enable == 1">
                        <a v-b-tooltip.hover title="冻结">
                          <i class="bx bx-downvote"></i>
                        </a>
                      </li>
                      <li class="list-inline-item px-2" @click="remove(item)">
                        <a v-b-tooltip.hover title="移除">
                          <i class="bx bx-trash"></i>
                        </a>
                      </li>
                    </ul> -->
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <!-- <pagination
            ref="page"
            @pageCallback="pageCallback"
            v-show="group_list.length"
          ></pagination> -->
          <app-list-loading ref="loading"></app-list-loading>
          <pagination
            class="bath_r_20"
            :isBatch="true"
            :total="pageTotal"
            :batchs="batchs"
            :pageSize="pageParams.pageSize"
            :page.sync="pageParams.page"
            :pageSizes="[10, 20, 30]"
            @pageCallback="pageCallback"
            ref="page"
          ></pagination>
        </div>
      </div>

      <!-- <b-modal v-model="detailModal" :title="detailTitle" centered size="lg">
        <div class="col-12 px-5">
          <div class="col-12  pb-4 flex-align-center">
            <div class="col-2 text-end pe-3">圈子名称</div>
            <div class="col-10">
              <b-input class="col-12" v-model="name"></b-input>
            </div>
          </div>

          <div class="col-12  pb-4 flex">
            <div class="col-2 text-end pe-3">图片</div>
            <div class="col-10">
              <image-upload size="1:1" ref="image"></image-upload>
              <div style="color: #aaa; margin-top: 5px;">
                图片比例 1:1，建议尺寸 600 * 600 px，建议文件小于1M
              </div>
            </div>
          </div>

          <div class="col-12  pb-4 flex">
            <div class="col-2 text-end pe-3">圈子简介</div>
            <div class="col-10">
              <b-form-textarea rows="3" v-model="description"></b-form-textarea>
            </div>
          </div>

          <div class="col-12  pb-4 flex">
            <div class="col-2 text-end pe-3">媒体号</div>
            <div class="col-10">
              <span class="pe-2" v-if="mediaName !== ''">{{ mediaName }}</span>
              <b-button
                variant="primary"
                class="px-3 py-1"
                pill
                @click="selectMedia"
                >选择</b-button
              >
            </div>
          </div>

          <div class="col-12  pb-4 flex">
            <div class="col-2 text-end pe-3">状态</div>
            <div class="col-10">
              <b-form-radio-group plain v-model="showDisabled">
                <b-form-radio :value="0">显示</b-form-radio>
                <b-form-radio :value="1">隐藏</b-form-radio>
              </b-form-radio-group>
            </div>
          </div>
        </div>

        <template #modal-footer>
          <b-button
            variant="outline-primary"
            @click="detailModal = false"
            style="margin-right:10px"
            >取消</b-button
          ><b-button variant="primary" @click="saveGroup">确认</b-button>
        </template>
      </b-modal> -->

      <el-dialog
        :title="detailTitle"
        :visible.sync="detailModal"
        class="top-draft-dialog"
        append-to-body
        :before-close="closeCreateModal"
        width="800px"
      >
        <div class="col-12 px-5">
          <div class="col-12 pb-4 flex-align-center">
            <div class="col-2 text-end pe-3"><span must>*</span>圈子名称</div>
            <div class="col-10">
              <b-input class="col-12" v-model="name"></b-input>
            </div>
          </div>

          <div class="col-12 pb-4 flex">
            <div class="col-2 text-end pe-3"><span must>*</span>图片</div>
            <div class="col-10">
              <image-upload size="1:1" ref="image"></image-upload>
              <div style="color: #aaa; margin-top: 5px">
                图片比例 1:1，建议尺寸 600 * 600 px，建议文件小于1M
              </div>
            </div>
          </div>

          <div class="col-12 pb-4 flex">
            <div class="col-2 text-end pe-3"><span must>*</span>圈子简介</div>
            <div class="col-10">
              <b-form-textarea rows="3" v-model="description"></b-form-textarea>
            </div>
          </div>

          <!-- <div class="col-12  pb-4 flex">
            <div class="col-2 text-end pe-3"><span must>*</span>媒体号</div>
            <div class="col-10">
              <span class="pe-2" v-if="mediaName !== ''">{{ mediaName }}</span>
              <b-button
                variant="primary"
                class="px-3 py-1"
                pill
                @click="selectMedia"
                >选择</b-button
              >
            </div>
          </div> -->
          <div class="col-12 pb-4 flex-align-center">
            <div class="col-2 text-end pe-3">运营</div>
            <div class="col-10 flex-align-center">
              <span>关注数：</span>
              <b-input
                style="width: 100px"
                v-model="operateFollowNum"
              ></b-input>
            </div>
          </div>

          <div class="col-12 pb-4 flex">
            <div class="col-2 text-end pe-3">状态</div>
            <div class="col-10">
              <b-form-radio-group plain v-model="showDisabled">
                <b-form-radio :value="0">显示</b-form-radio>
                <b-form-radio :value="1">隐藏</b-form-radio>
              </b-form-radio-group>
            </div>
          </div>
        </div>

        <div class="xb-footer">
          <b-button
            variant="outline-primary"
            @click="detailModal = false"
            style="margin-right: 20px"
            class="btn-sm btn-sm"
            >取消</b-button
          ><b-button variant="primary" class="btn-sm btn-sm" @click="saveGroup"
            >确认</b-button
          >

          <!-- <button
            class="btn-sm btn btn-outline-dark"
            type="button"
            style="margin-right:20px"
            @click="detailModal = false"
          >
            取消
          </button>
          <button
            class="btn-sm btn btn-primary"
            type="button"
            @click="saveGroup"
          >
            确定
          </button> -->
        </div>
      </el-dialog>

      <media-dialog @pageCallback="pageCallback" ref="media"></media-dialog>
      <!-- <img-detail ref="imgDetail"></img-detail> -->
    </div>
  </Layout>
</template>

<script>
import Vue from "vue";
import Swal from "sweetalert2";
import api from "@/server/api/media";
import Layout from "@/router/layouts/main";
import imageUpload from "@/components/imageUpload";
import groupApi from "@/server/api/group.js";
import mediaDialog from "@/components/choseMedia/mediaDialog.vue";
// import media from "../../../../server/api/media";
// import pagination from "@/components/pagination/pagination.vue";
import { getOperateNum } from "@/util/fun.js";
/**
 * Contacts-list component
 */
export default {
  components: {
    Layout,
    imageUpload,
    mediaDialog,
  },

  data() {
    return {
      id: undefined,
      pageTotal: 0,
      page: 1,
      pageSize: 10,
      detailTitle: "新建",
      power: "",
      choiceListIds: [], //当前所选择的id
      allListIds: [],
      indeterminate: false, //全选
      pageParams: {
        page: 1,
        pageSize: 10,
        verifyState: "", //审核状态，有来源时不传,0-未审核,1-通过,2-未通过
        content: "",
        showState: "",
      },
      group_list: [],
      statusOptions: [
        { text: "筛选状态", value: "" },
        // { text: "普通用户", value: "0" },
        { text: "显示", value: 0 },
        { text: "隐藏", value: 1 },
        // { text: "运营用户", value: "3" },
      ],
      stateList: [
        { text: "全部状态", value: "" },
        { text: "未审核", value: 0 },
        { text: "通过", value: 1 },
        { text: "未通过", value: 2 },
      ],
      showDetail: false,
      dialogItem: {},
      detailModal: false,
      batchs: [
        { text: "批量操作", value: "0" },
        // { text: "显示", value: "显示" },
        // { text: "隐藏", value: "隐藏" },
        // { text: "删除", value: "删除" },
      ],
      name: "",
      description: "",
      mediaId: undefined,
      mediaName: "测试",
      showDisabled: 0, //显示状态 0-显示,1不显示
      operateFollowNum: "", //运营关注数
    };
  },

  watch: {
    choiceListIds: function() {
      console.log("改变了", this.choiceListIds);
      if (
        this.choiceListIds.length == this.group_list.length &&
        this.choiceListIds.length > 0
      ) {
        this.indeterminate = true;
      } else {
        this.indeterminate = false;
      }
    },
  },

  mounted() {
    this.power = this.utils.currentPower("创作平台-圈子管理");
    if (this.power["显示/隐藏"]) {
      this.batchs.push({ text: "显示", value: "显示" });
      this.batchs.push({ text: "隐藏", value: "隐藏" });
    }
    if (this.power["移除"]) {
      this.batchs.push({ text: "删除", value: "删除" });
    }
    this.mediaId = JSON.parse(localStorage.chosedMedia).id;
    console.log("媒体号id", this.mediaId);
    // this.getList();
    // this.power = this.utils.currentPower("媒体号管理");
    this.getGroupList();
  },

  created() {
    this.pageParams.mediaId = JSON.parse(localStorage.chosedMedia).id;
    let params = this.another(this.pageParams);
    this.cleanObj(params);
  },

  methods: {
    //获取列表数据
    getList() {
      let params = this.another(this.pageParams);
      params.mediaId = this.mediaId;
      this.$refs.loading.show();
      api.list(params).then((resp) => {
        if (resp.data) {
          if (this.$refs.loading) {
            this.$refs.loading.hide(resp.data.items);
          }
          if (resp.data.items) {
            let ids = [];
            resp.data.items.map((item) => {
              ids.push(item.id);
            });
            this.choiceListIds = [];
            this.allListIds = ids; //当前列表全部id
            this.items = resp.data.items;
            // let pages = {
            //   page: resp.data.page, //第几页
            //   pageSize: resp.data.pageSize, //每页多少条
            //   total: resp.data.total, //全部有多少条数据
            //   totalPages: resp.data.totalPages, //全部有几页
            // };
            // if (!pages.totalPages) {
            //   pages.totalPages = Math.ceil(
            //     resp.data.total / resp.data.pageSize
            //   );
            // }
          }
        }
      });
    },
    saveGroup() {
      if (!this.name) {
        Vue.swal("名称未填写");
        return;
      }
      if (!this.description) {
        Vue.swal("简介未填写");
        return;
      }
      // if (!this.mediaId) {
      //   Vue.swal("未选择媒体号");
      //   return;
      // }
      let url = this.$refs.image.getImageUrl();
      if (!url) {
        Vue.swal("请上传封面图");
        return;
      }
      let operateFollowNum = getOperateNum(this.operateFollowNum, "follow");
      if (typeof operateFollowNum == "string") {
        this.warning(operateFollowNum);
        return;
      }
      let params = {
        name: this.name,
        description: this.description,
        mediaId: this.mediaId,
        cover: url,
        showDisabled: this.showDisabled,
        operateFollowNum,
      };
      console.log("保存参数", params);
      if (this.id !== undefined) {
        params.id = this.id;
        console.log("保存参数", params);
        groupApi.update(params).then((res) => {
          if (res.code === 0) {
            this.success("更新成功！");
            this.getGroupList();
            this.detailModal = false;
          } else {
            this.warning(res.msg);
            console.log(res);
          }
        });
      } else {
        groupApi.create(params).then((res) => {
          if (res.code === 0) {
            this.success("创建成功！");
            this.getGroupList();
            this.detailModal = false;
          } else {
            this.warning(res.msg);
            console.log(res);
          }
        });
      }
    },
    selectMedia() {
      this.$refs.media.showModel();
    },
    //给组件的回调
    pageCallback(obj) {
      console.log(obj);
      // if (obj.code == "media") {
      //   this.mediaId = obj.item.id;
      //   this.mediaName = obj.item.nickname;
      //   return;
      // }
      if (obj.code === "pageSize") {
        this.pageParams.pageSize = obj.ps;
        this.getGroupList();
      }
      if (obj.code === "page") {
        //更改页码
        this.pageParams.page = obj.page;
        this.getGroupList();
      }
      if (obj.code === "batch") {
        //处理批量操作
        console.log(this.choiceListIds);
        if (obj.batch == "删除") {
          if (this.choiceListIds.length) {
            this.confirm("确认删除所选内容？", this.deleteGroupBatch);
          } else {
            Vue.swal("请选择要删除的内容");
            return;
          }
        }
        if (obj.batch == "显示") {
          if (this.choiceListIds.length) {
            this.confirm("确认把已选内容更为显示状态？", () => {
              this.changeStatus(true);
            });
          } else {
            Vue.swal("请选择要更改的内容");
            return;
          }
        }
        if (obj.batch == "隐藏") {
          if (this.choiceListIds.length) {
            this.confirm("确认把已选内容更为隐藏状态？", () => {
              this.changeStatus(false);
            });
          } else {
            Vue.swal("请选择要更改的内容");
            return;
          }
        }
      }
    },

    //更改状态，如果judge存在则item为对象，否则为改为显示或不显示
    changeStatus(item) {
      let params = {};
      if (typeof item !== "boolean") {
        let arr = [];
        arr.push(item.id);
        params.id = arr;
        params.state = item.showDisabled ? 0 : 1;
      } else {
        params.id = this.choiceListIds;
        params.state = item ? 0 : 1;
      }
      groupApi.statusBatch(params).then((res) => {
        if (res.code === 0) {
          this.success("更改成功！");
          if (typeof item == "boolean") {
            this.choiceListIds = [];
          }
          this.getGroupList();
        } else {
          this.warning(res.msg);
          console.log(res);
        }
      });
    },
    deleteGroup(id) {
      this.confirm("确认删除？", () => {
        this.deleteGroupBatch(id);
      });
    },
    deleteGroupBatch(id) {
      let params = {};
      if (id !== undefined) {
        let arr = [];
        arr.push(id);
        params.ids = arr;
      } else {
        params.ids = this.choiceListIds;
      }
      console.log("删除的参数", params);
      groupApi.deleteBatch(params).then((res) => {
        if (res.code === 0) {
          this.success("删除成功！");
          this.getGroupList();
          if (id === undefined) {
            this.choiceListIds = [];
          }
        } else {
          this.warning(res.msg);
          console.log(res);
        }
      });
    },

    //搜索
    search() {
      this.pageParams.page = 1;
      this.getGroupList();
    },

    //重置搜索参数
    resetParams() {
      this.pageParams.page = 1;
      this.pageParams.showState = "";
      this.pageParams.verifyState = "";
      this.pageParams.content = "";
      this.getGroupList();
    },

    // 列表全选
    checkedAll(val) {
      console.log("全选", val);
      if (val) {
        let ids = [];
        this.group_list.map((item) => {
          ids.push(item.id);
        });
        this.choiceListIds = [];
        this.choiceListIds = ids;
      } else {
        this.choiceListIds = [];
      }
      // if (this.indeterminate) {
      //   this.choiceListIds = this.allListIds;
      // } else {
      //   this.choiceListIds = [];
      // }
    },

    handleClose() {
      this.showDetail = false;
    },

    // 创建
    openCreateModal() {
      this.id = undefined;
      this.detailTitle = "新建";
      this.dataInit();
      this.detailModal = true;
    },
    closeCreateModal() {
      this.detailModal = false;
    },
    dataInit() {
      this.id = undefined;
      this.name = "";
      this.description = "";
      // this.mediaId = undefined;
      this.mediaName = "";
      this.showDisabled = 0;
      if (this.$refs.image) {
        this.$refs.image.setImageUrl("");
      }
    },
    // 编辑
    toDetail(item) {
      console.log("编辑", item);
      this.detailTitle = "编辑";
      this.dataInit();
      this.id = item.id;
      this.name = item.name;
      this.description = item.desc;
      this.mediaName = item.mediaName;
      this.mediaId = item.mediaId;
      this.operateFollowNum = item.operateFollowNum || 0;
      this.detailModal = true;
      if (this.$refs.image) {
        this.$refs.image.setImageUrl(item.cover);
      } else {
        setTimeout(() => {
          this.$refs.image.setImageUrl(item.cover);
        }, 500);
      }

      //   this.$router.push({
      //     name: "groupDetail",
      //     query: { id: item.id, userType: item.userType },
      //   });
    },
    toContent(item) {
      this.$router.push({
        name: "groupContent",
        query: { id: item.id },
      });
    },
    remove(item) {
      // Swal.fire({
      //   title: "确定删除?",
      //   icon: "question",
      //   showCancelButton: true,
      //   confirmButtonColor: "#f46a6a",
      //   cancelButtonColor: "#74788d",
      //   confirmButtonText: "删除",
      //   cancelButtonText: "取消",
      // }).then((result) => {
      //   if (result.value) {
      //     // let params = {};
      //     // params.id = item.id;
      //     if (item) {
      //       params.push(item.id);
      //     } else {
      //       params.ids = this.choiceListIds;
      //     }
      //     groupApi.deleteBatch(params).then((resp) => {
      //       if (resp.code == 0) {
      //         Vue.swal({
      //           icon: "success",
      //           title: "删除成功！",
      //           showConfirmButton: false,
      //           timer: 1000,
      //         });
      //         this.getList();
      //       }
      //     });
      //   }
      // });

      this.confirm("确认删除？", () => {
        let params = {};
        if (item) {
          let arr = [];
          arr.push(item.id);
          params.ids = arr;
        } else {
          params.ids = this.choiceListIds;
        }
        groupApi.deleteBatch(params).then((resp) => {
          if (resp.code == 0) {
            Vue.swal({
              icon: "success",
              title: "删除成功！",
              showConfirmButton: false,
              timer: 1000,
            });
            this.getList();
          }
        });
      });
    },
    //获取圈子列表
    getGroupList() {
      let params = this.another(this.pageParams);
      this.cleanObj(params);
      params.mediaId = this.mediaId;
      console.log("圈子搜索参数", params);
      groupApi.list(params).then((res) => {
        console.log("圈子列表", res);
        if (res.code === 0) {
          if (this.$refs.loading) {
            this.$refs.loading.hide(res.data.items);
          }
          this.group_list = res.data.items;
          this.pageTotal = res.data.total;
        }
      });
    },
    //显示审核状态
    showState(state) {
      if (state === 0) {
        return "待审核";
      } else if (state === 1) {
        return "通过";
      } else if (state === 2) {
        return "驳回";
      } else {
        return "未知";
      }
    },
    //显示图片原图
    showImg(url) {
      console.log("显示图片");
      // this.$refs.imgDetail.showModal(url);
      this.ShowImg(url);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.tag-dialog .el-dialog {
  width: 30%;
}
.tag-dialog .el-dialog__body {
  padding-bottom: 0px;
}
.tag-dialog .main {
  padding-bottom: 24px;
}
</style>
